import * as z from "zod";
import { userFacingError } from "../authorization";
import { isFeatureFlagEnabled } from "../featureFlags";
import { STEP_TESTS_FEATURE_FLAG } from "../featureFlagNames";
import { STEP_TEST_PURPOSE } from "../stepTests/constants";
import { mutator } from "./mutator";
import { insertStepRun } from "./runStep";

export const runStepTestsSchema = z.object({
  runId: z.string(),
  workflowId: z.string(),
  commitId: z.string(),
  stepDir: z.string(),
  executionId: z.string(),
});

// A step-test run reuses the step's build (its content hash, computed by
// insertStepRun, excludes test files) but runs hermetically with a different
// command — see the orchestrator's step_test assembly.
export const runStepTests = mutator({
  schema: runStepTestsSchema,
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
    commit: { kind: "commit", from: "commitId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({
    tx,
    ctx,
    args: { runId, stepDir, executionId, workflow, commit },
  }) => {
    if (
      !(await isFeatureFlagEnabled(tx, STEP_TESTS_FEATURE_FLAG, ctx.tenantId))
    ) {
      throw userFacingError("Step tests are disabled");
    }
    await insertStepRun(tx, {
      runId,
      executionId,
      stepDir,
      workflow: {
        ...workflow,
        retentionSeconds: workflow.retentionSeconds!,
      },
      commit,
      purpose: STEP_TEST_PURPOSE,
      ephemeral: true,
      subject: "step tests",
      tenantId: ctx.tenantId,
    });
  },
});
